import axios from 'axios';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListaInstructores = () => {
  const [instructores, setInstructores] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Función para eliminar un instructor
  const deleteInstructor = async (id) => {
    try {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await axios.delete(`/api/instructores/${id}`);
          await getData(); // Refrescar los datos
          Swal.fire({
            icon: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    } catch (error) {
      console.error('Error al eliminar el instructor:', error.message);
      Swal.fire('Error', 'No se pudo eliminar el instructor.', 'error');
    }
  };

  // Función para obtener los datos
  const getData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get('/api/instructores/listall/');

      const instructoresConFunciones = (data?.instructores || []).map((instructor) => ({
        ...instructor,

        imagen: (
  <div className="d-flex justify-content-end justify-content-md-center align-items-center w-100">
    {instructor.imgInstructor ? (
      <img
        src={instructor.imgInstructor}
        alt="Instructor"
        className="rounded-circle border border-2"
        style={{ width: 46, height: 46, objectFit: "cover" }}
      />
    ) : (
      <div
        className="rounded-circle border border-2 d-flex justify-content-center align-items-center text-secondary bg-body-tertiary"
        style={{ width: 46, height: 46 }}
        title="Sin foto"
      >
        <i className="fa-solid fa-user"></i>
      </div>
    )}
  </div>
),

        funciones: (
          <div className="d-flex gap-2 flex-wrap justify-content-end">
            {/* 👁️ Ver firma */}
            <button
              className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center justify-content-center"
              style={{ width: 34, height: 34 }}
              data-bs-toggle="modal"
              data-bs-target={`#previewFirma${instructor._id}`}
              title="Ver Firma"
              type="button"
            >
              <i className="fa-solid fa-eye"></i>
            </button>

            {/* Registrar firma */}
            <button
              className="btn btn-dark btn-sm d-inline-flex align-items-center justify-content-center"
              style={{ width: 34, height: 34 }}
              onClick={() => navigate(`/instructor/registrarfirma/${instructor._id}`, { state: { instructor } })}
              title="Registrar Firma"
              type="button"
            >
              <i className="fa-solid fa-signature"></i>
            </button>

            {/* Listar contratos */}
            <button
              className="btn btn-outline-dark btn-sm d-inline-flex align-items-center justify-content-center"
              style={{ width: 34, height: 34 }}
              onClick={() => navigate(`/instructor/listarcontratos/${instructor._id}`)}
              title="Listar Contratos"
              type="button"
            >
              <i className="fa-solid fa-list-check"></i>
            </button>

            {/* Registrar contrato */}
            <button
              className="btn btn-dark btn-sm d-inline-flex align-items-center justify-content-center"
              style={{ width: 34, height: 34 }}
              onClick={() => navigate(`/instructor/registrarcontratos/${instructor._id}`, { state: { instructor } })}
              title="Registrar Contrato"
              type="button"
            >
              <i className="fa-solid fa-file-signature"></i>
            </button>

            {/* Editar */}
            <button
              className="btn btn-warning btn-sm d-inline-flex align-items-center justify-content-center"
              style={{ width: 34, height: 34 }}
              onClick={() => navigate(`/instructor/edit/${instructor._id}`, { state: { instructor } })}
              title="Editar Instructor"
              type="button"
            >
              <i className="fa-solid fa-pen-to-square"></i>
            </button>

            {/* Eliminar */}
            <button
              className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center"
              style={{ width: 34, height: 34 }}
              onClick={() => deleteInstructor(instructor._id)}
              title="Eliminar Instructor"
              type="button"
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </div>
        ),

        // Modal de firma
        modalFirma: (
          <div
            className="modal fade"
            id={`previewFirma${instructor._id}`}
            tabIndex="-1"
            aria-labelledby={`previewFirmaLabel${instructor._id}`}
            aria-hidden="true"
            key={`modal-${instructor._id}`}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 rounded-4 shadow">
                <div className="modal-header border-bottom">
                  <div>
                    <h6 className="modal-title fw-semibold mb-0" id={`previewFirmaLabel${instructor._id}`}>
                      Firma del instructor
                    </h6>
                    <div className="small text-secondary">
                      {instructor.nombre1Instructor} {instructor.apellido1Instructor}
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Cerrar"
                  ></button>
                </div>

                <div className="modal-body text-center">
                  {instructor.firmaInstructor ? (
                    <img
                      src={instructor.firmaInstructor}
                      alt="Firma del Instructor"
                      className="img-fluid border p-2 rounded-3 bg-white"
                      style={{ maxHeight: 260 }}
                    />
                  ) : (
                    <div className="py-4">
                      <div className="display-6">🐾</div>
                      <p className="text-muted mb-0">Este instructor no tiene firma registrada.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ),
      }));

      setInstructores(instructoresConFunciones);
    } catch (error) {
      console.error('Error al cargar los instructores:', error.message);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, []);

  // Ejecutar getData cuando el componente se monte
  useEffect(() => {
    getData();
  }, [getData]);

  const columns = useMemo(
    () => [
      { accessor: 'imagen' },
      { Header: 'Documento', accessor: 'documentoInstructor' },
      { Header: 'Nombre', accessor: 'nombre1Instructor' },
      { Header: 'Apellido', accessor: 'apellido1Instructor' },
      { Header: 'Edad', accessor: 'edadInstructor' },
      { Header: 'Sexo', accessor: 'sexoInstructor' },
      {
        Header: 'Email',
        accessor: 'emailInstructor',
        width: 280,
        hideHeaderOnMobile: true,
      },
      { accessor: 'funciones' },
    ],
    []
  );

  return (
    <div>
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
          {/* Header */}
          <div className="px-3 px-md-4 py-3 border-bottom bg-white">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <h5 className="mt-2 mb-1 fw-semibold">Instructores</h5>
                <small className="text-secondary">
                  Gestión institucional y generación de documentos.
                </small>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => getData()}
                  title="Actualizar"
                  disabled={loading}
                >
                  <i className={`fa-solid ${loading ? 'fa-spinner fa-spin' : 'fa-rotate'} me-2`}></i>
                  Actualizar
                </button>

                <button
                  className="btn btn-dark"
                  type="button"
                  onClick={() => navigate('/instructor/nuevo')}
                  title="Crear Instructor"
                >
                  <i className="fa-solid fa-plus me-2"></i>
                  Nuevo
                </button>
              </div>
            </div>
          </div>

          {/* Body */}
          <div>
            {loading ? (
              <div className="text-center text-secondary py-5">
                <div className="spinner-border" role="status" aria-hidden="true"></div>
                <div className="mt-3">Cargando instructores…</div>
              </div>
            ) : Array.isArray(instructores) && instructores.length > 0 ? (
              <>
                <div className="overflow-hidden">
                  <DataTable columns={columns} data={instructores} />
                </div>

                {/* Renderizar todos los modales debajo de la tabla */}
                {instructores.map((i) => i.modalFirma)}
              </>
            ) : (
              <div className="text-center text-secondary py-5">
                <div className="display-6 mb-2">🐾</div>
                <div className="fw-semibold">No hay instructores registrados</div>
                <div className="small mb-3">Crea el primer registro para iniciar la gestión.</div>
                <button
                  className="btn btn-dark"
                  type="button"
                  onClick={() => navigate('/instructor/registrarinstructores')}
                >
                  <i className="fa-solid fa-plus me-2"></i>
                  Registrar instructor
                </button>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default ListaInstructores;